<template>
  <section>
    <h2 class="h2Title">모임 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="모임 생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>


              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 / 장소 / 주소 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList" style="padding-right: 2px">
              <v-btn color="success" dark @click="excelUploadDialog">
                <v-icon left dark>cloud_upload</v-icon>
                엑셀 업로드
              </v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="$router.push({path: 'meeting/form'})" color="#666" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="datasets"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="meetingId"
            class="elevation-1"
        >
          <template v-slot:item.group.groupName="{value, item}">
              {{item.group.parent ? item.group.parent.groupName + ' / ' : ''}}{{ value }}
          </template>


          <template v-slot:item.title="{value}">
<!--            <a @click.stop="onRowClick(item.meetingId)">-->
            {{ value }}
<!--            </a>-->
          </template>

          <template v-slot:item.startDt="{ value, item }">
            {{ item.startDt | moment('YYYY-MM-DD') }} {{ item.startTm }} ~ {{ item.endDt | moment('YYYY-MM-DD') }} {{ item.endTm }}
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.activated="{ value, item }">
            {{ value ? `노출 ${item.postDt ? '(노출 시작 일 : ' + item.postDt +')' : ''}` : '미노출' }}
          </template>
          <template v-slot:item.state="{ value }">
            {{ getState(value) }}
          </template>


          <template v-slot:item.entryFee="{value}">
            <template v-if="value !== '0'">
              {{ value | numeralFormat('0,000')}} 원
            </template>
            <template v-else>
              없음
            </template>
          </template>
          <template v-slot:item.joinCount="{value, item}">
            <router-link :to="`meeting/${item.meetingId}/users`" v-if="value > 0">
            {{value}} 명
            </router-link>
            <template v-else>
              -
            </template>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click.stop="updateForm(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
                small
                @click.stop="deleteMeeting(item)"
            >
              mdi-delete
            </v-icon>
          </template>


        </v-data-table>
      </div>
    </article>

    <v-dialog v-model="excelDialog" max-width="500px" @click:outside="excelDialog = false" @keydown.esc="excelDialog = false">
      <v-card>
        <v-card-title>
          <span class="headline">모임 일괄 등록</span>
        </v-card-title>

        <v-card-text>
          <div class="fieldWrap mgb2">
            <ul class="fieldBx">
              <li class="formList">
                <dl>
                  <dd class="mgr">
                    <v-btn href="/attachment/group/eclub_meeting.xlsx" class="vBtn vIconResize mgr" color="primary" dark>
                      <v-icon left dark>cloud_download</v-icon>
                      모임 게시물 형식 파일 다운로드</v-btn>
                  </dd>
                </dl>
              </li>
              <li class="formList">
                <dl>
                  <dt class="formTit">엑셀 파일</dt>
                  <dd class="mgr">
                    <v-file-input
                        accept=".xlsx, .xls" placeholder="모임 게시물 형식의 엑셀 파일을 선택해주세요."
                        prepend-icon="mdi-file-excel"
                        v-model="excelFile"
                    />
                  </dd>
                </dl>
              </li>
            </ul>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" dark @click="excelDialog = false">창닫기</v-btn>
          <v-btn color="primary" dark @click="excelUpload()">업로드</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";

import meetingApi from '@/api/MeetingApi'
// import _ from "lodash";

export default {
  name: "Meeting",
  components: {
    'date-range-component': DateRageComponent
  },
  data: () => ({
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    activeItem: null,
    selected: [],
    headers: [
      {text: '번호', value: 'idx', sortable: false},
      {text: '카테고리', value: 'group.groupName', sortable: false},
      {text: '제목', value: 'title', align: 'left', sortable: false},
      {text: '장소', value: 'place', align: 'center', sortable: false},
      {text: '모임일', value: 'startDt', sortable: false},
      {text: '노출여부', value: 'activated', align: 'left', sortable: false},
      {text: '상태', value: 'state', align: 'left', sortable: false},
      {text: '참가비', value: 'entryFee', align:'left', sortable: false},
      {text: '참여인원', value: 'joinCount', align:'left', sortable: false},
      {text: '등록일', value: 'createdAt', align: 'left', sortable: false},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchDate:[],
      searchState: null,
      searchRole: null,
      searchKeyword: null,
      page: 1
    },
    datasets: [],
    totalItems: 0,
    waitingSearch: false,
    options:{},
    stateItems:[
      {text:'마감', value:'STATE_END'},
      {text:'접수중', value:'STATE_RECEIPT'},
      {text:'접수대기', value:'STATE_READY'}
    ],
    excelDialog: false,
    excelFile: null
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  computed: {

  },
  methods: {
    excelUploadDialog() {
      this.excelDialog = true;
    },
    excelUpload() {
      if(!this.excelFile) {
        alert("파일을 선택해주세요");
        return;
      }
      if(confirm('일괄 등록 하시겠습니까?')) {
        meetingApi.uploadExcel(this.excelFile).then(() => {
          this.excelDialog = false;
          this.excelFile = null;
          this.search();
          alert("완료되었습니다.");
        });
      }
    },
    getState(value) {
      return (this.stateItems?.filter(s => s.value === value)?.[0]??{}).text??''
    },
    onRowClick(value) {
      this.$router.push({path:`/group/meeting/${value}`});
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    search() {
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
            page: page,
            size: size ? size : itemsPerPage
      }};

      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      meetingApi.list(params).then(data => {
        this.totalItems = data.totalElements;
        this.datasets = data.content.map((b, i) => {
          b.idx = this.totalItems - i - (( (params.page??1) - 1) * params.size);
          return b;
        });
        this.$store.commit('setParams', params);
      });
    },
    updateForm(item) {
      this.$router.push({path:`/group/meeting/form/${item.meetingId}`});
    },
    deleteMeeting(item) {
      if(confirm('삭제하시겠습니까?')) {
        meetingApi.delete(item.meetingId).then(() => {
          this.search();
        });
      }
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
